<template lang="pug">

  .answers-task-question-info
    .answers-card__body
      p.answers-task-question__name(v-if="systemName")
        | {{systemName}}
      .lesson-block__markdown.form-item__markdown(
        v-html="makeHtml(taskItem.question.question)"
      )
      .answers-task-question-date
        p.answers-task-question-date__ddl
          | DDL {{ddlDate}}
        p.answers-task-question-date__answer
          | {{answerCreatedAt}}

      p.main-block__label.answers-card__label
        | Ответ участника:

      ToggleTextBlock.main-block__text.answers-card__text.-pre-line-(
        :text="answerHTML"
      )

      .answers-card__row(v-if="taskItem.answer.files && taskItem.answer.files.length")
        File(
          v-for="(file, idx) in taskItem.answer.files" :key="file.fileName + idx"
          :file="file"
          :canDelete="false"
        )

</template>

<script>
import ToggleTextBlock from '@/components/Form/ToggleTextBlock';
import File from '@/components/File/File';
import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';
import markdownToHtml from '@/functions/converterMarkdownToHtml';

export default {
  components: { File, ToggleTextBlock },
  props: ['taskItem', 'systemName', 'ddlDate', 'answerCreatedAt'],
  computed: {
    answerHTML() {
      return textToHtmlWithLinks(this.taskItem.answer.answer);
    }
  },
  methods: {
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    }
  }
};
</script>
